/* ============================================================
   เลือกไฟล์แนบหลายไฟล์ (ยังไม่อัปโหลด — ส่งพร้อมฟอร์ม)
   <FilePicker value={files} onChange={setFiles} />
============================================================ */
import React from "react";
import { Button, Upload, message } from "antd";
import { InboxOutlined, PaperClipOutlined } from "@ant-design/icons";
import { FILE_ACCEPT, FILE_MAX_COUNT, FILE_MAX_MB } from "../../utils/fileOpen";

const OK_EXT = FILE_ACCEPT.split(",");

/* mode = "drag" กล่องลากวาง , "button" ปุ่มแนบไฟล์เล็ก ๆ (ช่องตอบกลับ) */
export default function FilePicker({ value = [], onChange, hint, compact = false, max = FILE_MAX_COUNT, mode = "drag" }) {
  const beforeUpload = (file, list) => {
    const ext = "." + (file.name.split(".").pop() || "").toLowerCase();
    if (!OK_EXT.includes(ext)) {
      message.error(`ไม่รองรับไฟล์ ${file.name}`);
      return Upload.LIST_IGNORE;
    }
    if (file.size > FILE_MAX_MB * 1024 * 1024) {
      message.error(`${file.name} ใหญ่เกิน ${FILE_MAX_MB} MB`);
      return Upload.LIST_IGNORE;
    }
    if (value.length + list.indexOf(file) >= max) {
      if (list.indexOf(file) === list.length - 1) message.warning(`แนบได้ครั้งละไม่เกิน ${max} ไฟล์`);
      return Upload.LIST_IGNORE;
    }
    return false; // ไม่อัปโหลดทันที
  };

  if (mode === "button")
    return (
      <Upload multiple accept={FILE_ACCEPT} fileList={value} beforeUpload={beforeUpload} onChange={({ fileList }) => onChange?.(fileList.slice(0, max))}>
        <Button icon={<PaperClipOutlined />}>แนบไฟล์</Button>
      </Upload>
    );

  return (
    <Upload.Dragger
      multiple
      accept={FILE_ACCEPT}
      fileList={value}
      beforeUpload={beforeUpload}
      onChange={({ fileList }) => onChange?.(fileList.slice(0, max))}
      className={compact ? "ak-picker ak-picker-compact" : "ak-picker"}
    >
      <p className="ant-upload-drag-icon" style={{ marginBottom: compact ? 4 : 8 }}>
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">แตะเพื่อเลือกไฟล์ หรือลากไฟล์มาวาง</p>
      <p className="ant-upload-hint">{hint || `PDF รูปภาพ DWG Word Excel ZIP · ไฟล์ละไม่เกิน ${FILE_MAX_MB} MB · สูงสุด ${max} ไฟล์`}</p>
    </Upload.Dragger>
  );
}
